@if (visible()) {
  <div class="jen-exists-elsewhere">
    <img class="jen-exists-avatar" src="assets/img/jen/jen_zen_with_shadow.svg" alt="JenZen" />
    <div class="jen-exists-bubble jen-exists-bubble--error">
      One or more of these entities already exist under a different entity on
      <span class="where"><i class="material-symbols-rounded">account_balance</i>{{ customerLabel() }}</span>.
      Let's migrate this import to the customer level — you'll see the full portfolio there and can link everything where it lives.
      <span class="link-hint">Or fix the data on the rows below, or abort this import.</span>
      <div class="jen-actions">
        <button class="btn-primary" [disabled]="isMigrating()" (click)="migrate()">Migrate to customer level</button>
        <button class="btn-secondary" [disabled]="isMigrating()" (click)="abort()">Abort import</button>
      </div>
    </div>
  </div>
}
